import buttonTheme from './components/Button/defaultTheme.json';
import inputRangeTheme from './components/InputRange/defaultTheme.json';
import legendRangeTheme from './components/Legend/defaultTheme.json';

export default {
  ...buttonTheme,
  ...inputRangeTheme,
  ...legendRangeTheme
};
